module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [(_vm.pageCount) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 3,
      "click-handler": _vm.onClick,
      "prev-text": "«",
      "next-text": "»",
      "container-class": "pagination justify-content-center",
      "next-class": "page-item",
      "next-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "page-class": "page-item",
      "page-link-class": "page-link"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small text-center"
  }, [_vm._v(_vm._s(_vm.fromItem) + " - " + _vm._s(_vm.toItem) + " от " + _vm._s(_vm.total))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30a6658d!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/f-pager.vue
// module id = 646
// module chunks = 1